import { FC, useContext } from 'react'
import DownloadShipmentSourceFiles from '../../../../../components/buttons/download-shipment-source-files/download-shipment-source-files'
import Task from '../../../../../types/api/task'
import { DesignerTasksScaleContext } from '../../../constants/scale-context'

interface SourceFileProps {
    task: Task
}

const SourceFile: FC<SourceFileProps> = ({ task }) => {
    const isLarge = useContext(DesignerTasksScaleContext) === 'large'
    return (
        <DownloadShipmentSourceFiles
            shipmentDocumentId={task.shipment?.documentId ?? ''}
            buttonProps={{ children: 'Скачать', size: isLarge ? 'middle' : 'small' }}
        />
    )
}

export default SourceFile
